export const state = () => ({
  lastFetch: null,
})

export const mutations = {
  setLastFetch: (state, payload) => {
    state.lastFetch = payload
  },
  reset: state => {
    state.lastFetch = null
  },
}
